import { ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Flex, Modal, Space, Typography } from "antd";

const { Text } = Typography;

const DeliverySettingsConfirmDialog = ({
  showConfirmDialog,
  setShowConfirmDialog,
  handleSave,
  isSubmitting,
}) => {
  const handleConfirm = () => {
    handleSave();
  };

  const handleCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <Modal
      closable={false}
      centered={true}
      open={showConfirmDialog}
      footer={null}
    >
      <Flex style={{ marginBottom: "20px" }}>
        <Space align="start" size="middle">
          <ExclamationCircleFilled style={{ fontSize: "25px", color: "#007AFF" }} />
          <Space.Compact direction="vertical">
            <Text
              strong
              style={{
                fontSize: "20px",
                paddingBottom: "10px",
                lineHeight: "1.3"
              }}
            >
              Save changes
            </Text>
            <Text style={{ fontSize: "16px" }}>Are you sure you want to submit this information?</Text>
          </Space.Compact>
        </Space>
      </Flex>
      <Flex justify="end">
        <Space size="middle">
          <Button
            htmlType="button"
            disabled={isSubmitting}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            htmlType="submit"
            variant="solid"
            style={{
              color: "#FFFFFF",
              background: "#34C759"
            }}
            loading={isSubmitting}
            disabled={isSubmitting}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Space>
      </Flex>
    </Modal>
  );
};

export default DeliverySettingsConfirmDialog;